var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5p"},[_c('div',{staticClass:"container"},[_vm._t("default")],2),_c('footer',{staticClass:"footer footer-alt"},[(_vm.appConfig.empresa != 'sisloc')?_c('span',{staticClass:"footer-text"},[_vm._v(" Copyright 2020 © "+_vm._s(_vm.appConfig.company)+". Todos os direitos reservados. ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }